import { Http } from "./Http";

export const getRecommendations = (companyId, runDate) => {
  let url = "companies/" + companyId + "/inventory/recommendations";
  if (runDate) url += "?runDate=" + runDate;
  return Http.get(url);
};

export const runRecommendations = (companyId) => {
  return Http.post("companies/" + companyId + "/inventory/recommendations/run");
};

export const getPolicies = (companyId) => {
  return Http.get("companies/" + companyId + "/inventory/recommendations/policies");
};

export const createPolicy = (companyId, data) => {
  return Http.post("companies/" + companyId + "/inventory/recommendations/policies", data);
};

export const updatePolicy = (companyId, id, data) => {
  return Http.put("companies/" + companyId + "/inventory/recommendations/policies/" + id, data);
};

export const deletePolicy = (companyId, id) => {
  return Http.delete("companies/" + companyId + "/inventory/recommendations/policies/" + id);
};
